<template lang="pug">
  #ModalConfirmation
    .text-center
      b-icon(icon="x-circle" style="width: 80px; height: 80px; margin-bottom: 20px;" variant="danger")
      h2 ¿Estás Seguro?
      p Seguro que desea eliminar al estado "{{selected.name}}" para el servicio seleccionado
    .modal-footer
      b-button(@click="hideModal" variant="outline-muted") Cancelar
      b-button(@click="deleteState(selected)" variant="danger") Eliminar
</template>
<script>
import { mapActions } from 'vuex';
export default {
  props: ['hideModal', 'selected', 'makeToast'],
  methods: {
    ...mapActions(['deleteServiceState']),
    async deleteState() {
      const response = await this.deleteServiceState(this.selected);
      if (response.status === 200) {
        this.makeToast("success", response.data.message, "Éxito!");
        this.hideModal();
      } else {
        this.makeToast("danger", response.data, "Ocurrió un error!");
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#ModalConfirmation{
  flex-direction: column;
  align-items: center;
  p {
      margin: 0;
  }

  #title {
    font-size: 24px;
    font-weight: 600;
    color: #323338;
    margin-bottom: 30px;
  }

  #body {
    text-align: center;
    font-size: 14px;
    color: #7F828F;
    margin-bottom: 30px;
  }

  #buttons {
    align-self: flex-end;
    margin-bottom: 0;
  }
  .modal-footer {
    padding: 0;
  }
}
</style>